export enum PaymentStatus {
  SUCCESS = 'success',
  FAILED = 'failed'
}
